    const specificationsData = [
    {
        paroductName:'NVMD-C200',
        specifications:[
            { 
                specificRow:'Sensor Specifications',
                data:[
                    {title:'Resolution',param:'1920 × 1080 pixels'},
                    {title:'Sensor Frame Rate',param:'50 fps'},
                    {title:'Recording Format',param:'1920 × 1080 pixels @ 50 FPS'}
                ]
            },
            { 
                specificRow:'Optical Specifications',
                data:[
                    {title:'Digital Magnification',param:'1-6x'},
                    {title:'Eye Relief',param:'65 mm / 2.6 in'},
                    {title:'Field of View',param:'27.0° × 15.4° / 48 yd × 27 yd @100 yd'},
                    {title:'Diopter Adjustment',param:'±2D'}
                ]
            },
            { 
                specificRow:'Display Specifications',
                data:[
                    {title:'Type',param:'Micro-OLED'},
                    {title:'Display Resolution',param:'1920 × 1080 pixels'},
                    {title:'Frame Rate',param:'50 Hz'}
                ]
            },
            { 
                specificRow:'Battery Power Supply',
                data:[
                    {title:'Battery Type',param:'18650 Battery (Flat-top)'},
                    {title:'Operating Time',param:'6 h'},
                    {title:'External Power Supply',param:'5V USB-C'}
                ]
            },
            { 
                specificRow:'Physical Specifications',
                data:[
                    {title:'Net Weight',param:'390 g / 13.76 oz'},
                    {title:'Total Weight (incl. Battery & QDS-150)',param:'Approx. 587 g / 20.71 oz'},
                    {title:'Dimensions',param:'99 × 73 × 63mm / 3.9 × 2.9 × 2.5 in'},
                    {title:'Built-in Memory',param:'32 GB eMMC'},
                    {title:'Ingress Protection Rating',param:'IP67'},
                    {title:'Recoil Rating',param:'800 Gs / .50 BMG'},
                    {title:'Connections /App',param:'Wi-Fi/ DNT APP'}
                ]
            }
        ]
    },
    
    {
        paroductName:'ZT4K324R',
        specifications:[
            { 
                specificRow:'Sensor Specifications',
                data:[
                    {title:'Resolution',param:'3840 × 2160 pixels'},
                    {title:'Sensor Frame Rate',param:'60fps @ 1080P / 30fps @ 4K'},
                    {title:'Recording Format',param:'1920 × 1080 pixels'}
                ]
            },
            { 
                specificRow:'Optical Specifications',
                data:[
                    {title:'Digital Magnification',param:'3 - 24x'},
                    {title:'Eye Relief',param:'65 mm / 2.6 in'},
                    {title:'Field of View',param:'8.8° × 4.9° / 15.4 yd × 8.6 yd @100 yd'},
                    {title:'Diopter Adjustment',param:'±3D'}
                ]
            },
            { 
                specificRow:'Display Specifications',
                data:[
                    {title:'Type',param:'Micro-OLED'},
                    {title:'Display Resolution',param:'1920 × 1080 pixels'},
                    {title:'Frame Rate',param:'60 Hz'}
                ]
            },
            { 
                specificRow:'Battery Power Supply',
                data:[
                    {title:'Battery Type',param:'21700 Battery (Flat-top)'},
                    {title:'Operating Time',param:'6 h'},
                    {title:'External Power Supply',param:'5V USB-C'}
                ]
            },
            { 
                specificRow:'Physical Specifications',
                data:[
                    {title:'Net Weight',param:'690 g / 24.3 oz'},
                    {title:'Total Weight (incl. Battery & Rings)',param:'Approx. 895 g / 29.5 oz'},
                    {title:'Dimensions',param:'347×83×65.3 mm / 13.7×3.3×2.6 inches'},
                    {title:'Built-in Memory',param:'64 GB eMMC'},
                    {title:'Ingress Protection Rating',param:'IP67'},
                    {title:'Recoil Rating',param:'800 Gs / .50 BMG'},
                    {title:'Connections /App',param:'Wi-Fi / DNT APP'}
                ]
            }
        ]
    },

    {
        paroductName:'TNC4K219R',
        specifications:[
            { 
                specificRow:'Digital Day/Night Specifications',
                data:[
                    {title:'Sensor Resolution',param:'3840 × 2160 pixels'},
                    {title:'Sensor Frame Rate',param:'30 fps'},
                    {title:'Objective Lens',param:'50 mm f/1.8'},
                    {title:'Base Magnification',param:'3x'},
                    {title:'Digital Magnification',param:'3x, 4.5x, 6x, 9x, 12x, 18x, 24x'},
                    {title:'Field Of View (FOV)',param:'8.8° / 4.9° / 10.1°'},
                    {title:'Linear FOV<span class="remark_txt">(yd @100 yd | m @ 100 m)</span>',param:'15.4 / 8.6 / 17.6 '},
                ]
            },
            { 
                specificRow:'Thermal Specifications',
                data:[
                    {title:'Sensor Type',param:'Uncooled thermal detector'},
                    {title:'Sensor Resolution',param:'256 × 192 pixels'},
                    {title:'Sensor Frame Rate',param:'40 fps'},
                    {title:'Pixel Pitch',param:'12 μm'},
                    {title:'NETD',param:'≤18 mK (@25°C / 77°F)'},
                    {title:'Objective Focal Length',param:'19 mm'},
                    {title:'Base Magnification',param:'2x'},
                    {title:'Digital Magnification',param:'2x, 3x, 4x, 5x, 6x, 7x, 8x'},
                    {title:'Field Of View (FOV)',param:'9.2° / 6.9° / 11.5° '},
                    {title:'Linear FOV<span class="remark_txt">(yd @100 yd | m @ 100 m)</span>',param:'16.2 / 12.1 / 20.2 '},
                ]
            },
            { 
                specificRow:'Physical Specifications',
                data:[
                    {title:'Net Weight',param:'737 g / 26.0 oz'},
                    {title:'Dimensions',param:'196 × 82 × 78 mm / 7.7 × 3.2 × 3.1 in'},
                    {title:'Operating Temperature',param:'-20 to 50°C / -4 to 122°F'},
                    {title:'Ingress Protection Rating',param:'IP67'},
                    {title:'Recoil Rating',param:'800Gs / .50 BMG'},
                ]
            },
            { 
                specificRow:'Display & Ocular Specifications',
                data:[
                    {title:'Display Type',param:"0.49' Micro-OLED"},
                    {title:'Display Resolution',param:'1920 × 1080 pixels'},
                    {title:'Display Refresh Rate',param:'60 Hz'},
                    {title:'Eye Relief',param:'65 mm'},
                ]
            },
            { 
                specificRow:'Peripheral Specifications',
                data:[
                    {title:'Battery Type',param:"Rechargeable 21700 Flat-top Li-ion Battery"},
                    {title:'Operating Time',param:'5h 45m'},
                    {title:'External Power Supply',param:'5 V USB-C'},
                    {title:'Storage',param:'Built-in Storage, 64 GB'},
                    {title:'Connections',param:'Wi-Fi / DNT App'},
                ]
            },
        ]
    },
    {
        paroductName:'ZHD520R-V2',
        specifications:[
            { 
                specificRow:'Sensor Specifications',
                data:[
                    {title:'Resolution',param:'1920×1080 pixels'},
                    {title:'Sensor Frame Rate',param:'60 Hz'},
                    {title:'Video Record Resolution',param:'1800×1080 pixels'},
                ]
            },
            { 
                specificRow:'Optical Specifications',
                data:[
                    {title:'Digital Magnification',param:'5 ~ 20x'},
                    {title:'Eye Relief',param:'65 mm / 2.7 inches'},
                    {title:'Diopter Adjustment',param:'±3D'},
                ]
            },
            { 
                specificRow:'Display Specifications',
                data:[
                    {title:'Type',param:'Micro-OLED'},
                    {title:'Display Resolution',param:'1920×1080 pixels'},
                    {title:'Frame Rate',param:'60 Hz'},
                ]
            },
            { 
                specificRow:'Battery Power Supply',
                data:[
                    {title:'Battery Type',param:"21700 Battery (Flat-top)"},
                    {title:'Operating Time',param:'10 h'},
                    {title:'External Power Supply',param:'5V - Type C USB'},
                ]
            },
            { 
                specificRow:'Physical Specifications',
                data:[
                    {title:'Net Weight',param:"542 g / 19.1 oz"},
                    {title:'Memory',param:'Built-in Memory, 32GB'},
                    {title:'Dimensions',param:'6.4×3.0×2.1 inches'},
                    {title:'Waterproof',param:"IP67"},
                    {title:'Wi-Fi / App',param:'YES (DNT)'},
                    {title:'Operation Distance',param:'5–1000 m / 5–1100 yards'},
                    {title:'Operating Temperature',param:'−20~50 °C / −4~122 °F'},
                    {title:'Recoil Proof',param:'.50BMG'}
                ]
            }
        ]
    },
    {
        paroductName:'HS210M',
        specifications:[
            { 
                specificRow:'Thermal Sensor Specifications',
                data:[
                    {title:'Sensor Resolution',param:'256 × 192 pixels'},
                    {title:'Sensor Type',param:'Uncooled Infrared Sensor'},
                    {title:'Sensor Frame Rate',param:'40 fps'},
                    {title:'Pixel Size',param:'12 × 12 μm'},
                    {title:'NETD<span class="remark_txt">(Noise Equivalent Temperature Difference)</span>',param:'≤18 mK(@25°C / 77°F)'},
                ]
            },
            { 
                specificRow:'Optical Specifications',
                data:[
                    {title:'Focal Length of Objective Lens',param:'10 mm'},
                    {title:'Base Magnification',param:'1x (1.14x)'},
                    {title:'Digital Zoom',param:'1x, 2x, 4x'},
                    {title:'Field Of View (FOV)<span class="remark_txt">(Horizontal / Vertical / Diagonal)</span>',param:'17.5° / 13.7° / 21.7°'},
                    {title:'Linear FOV<span class="remark_txt">(m @ 100m / yd @ 100 yd Horizontal / Vertical / Diagonal)</span>',param:'30.7 / 23.0 / 38.4'},
                    {title:'Eye Relief',param:'65 mm / 2.6 in'},
                ]
            },
            { 
                specificRow:'Display Specifications',
                data:[
                    {title:'Display Type',param:'Micro-OLED'},
                    {title:'Display Resolution',param:'1024 × 768 pixels'},
                    {title:'Display Refresh Rate',param:'50 Hz'}
                ]
            },
            { 
                specificRow:'Power Specifications',
                data:[
                    {title:'Battery Type',param:'18650 Battery (Flat-top)'},
                    {title:'Operating Time',param:'7 h'},
                    {title:'External Power Supply',param:'5 V USB-C'}
                ]
            },
            { 
                specificRow:'Physical Specifications',
                data:[
                    {title:'Net Weight',param:'320 g / 11.3 oz'},
                    {title:'Total Weight<span class="remark_txt">(Incl. Battery and Mount)</span>',param:'550 g / 19.4 oz'},
                    {title:'Dimensions',param:'103 × 68 × 51 mm 4.1 × 2.7 × 2.0 in'},
                    {title:'Chassis Material',param:'Aluminum Alloy'},
                    {title:'Operating Temperature',param:'−20 to 50°C / −4 to 122°F'},
                    {title:'Ingress Protection Rating',param:'IP 67'},
                    {title:'Recoil Rating',param:'800 Gs / .50 BMG'},
                ]
            },
            { 
                specificRow:'System Specifications',
                data:[
                    {title:'Storage',param:'Built-in Storage, 32 GB'},
                    {title:'Recording Format',param:'1024 × 768 pixels @ 50 fps*'},
                    {title:'Connections',param:'Wi-Fi / DNT App'},
                ]
            },
        ]
    }
]